import { BridgeComponent } from "@hotwired/strada"
import { Offcanvas } from "bootstrap"

export default class extends BridgeComponent {
  static component = "notifications-button"
  static targets = ["trigger"]
  static values = { unreadCount: Number }

  connect() {
    super.connect()
    this.prepareOffcanvas()
    window.__depozenOpenNotifications = () => this.openOffcanvas()
    this.onBridgeReady = () => this.notifyBridge()
    document.addEventListener("web-bridge:ready", this.onBridgeReady)
    this.onFeedSubmit = (event) => this.watchFeedSubmit(event)
    this.onFeedRender = (event) => this.syncUnreadCount(event)
    document.addEventListener("turbo:submit-end", this.onFeedSubmit)
    document.addEventListener("turbo:frame-render", this.onFeedRender)
    this.notifyBridge()
  }

  disconnect() {
    document.removeEventListener("web-bridge:ready", this.onBridgeReady)
    document.removeEventListener("turbo:submit-end", this.onFeedSubmit)
    document.removeEventListener("turbo:frame-render", this.onFeedRender)
    delete window.__depozenOpenNotifications
    super.disconnect()
  }

  triggerTargetConnected() {
    this.notifyBridge()
  }

  // Les apps n'ont pas le flux temps réel de la cloche : le fil, rechargé quand on y lit des
  // notifications, donne le nouveau nombre de non lues à la cloche native (et à la pastille iOS).
  // Seulement après une action dans le fil : son premier chargement peut finir quand l'app a déjà
  // ouvert l'écran suivant (notification touchée au démarrage), qui recevrait la cloche.
  watchFeedSubmit(event) {
    if (event.target.closest?.("#notifications_feed")) this.feedSubmitted = true
  }

  syncUnreadCount(event) {
    if (event.target.id !== "notifications_feed" || !this.feedSubmitted) return

    this.feedSubmitted = false
    const count = event.target.querySelector("[data-unread-count]")?.dataset.unreadCount
    if (count !== undefined) this.unreadCountValue = Number(count)
  }

  unreadCountValueChanged() {
    this.notifyBridge()
  }

  notifyBridge() {
    if (!this.enabled) return

    this.send("connect", { unreadCount: this.unreadCountValue })
  }

  prepareOffcanvas() {
    const panel = document.getElementById("notifications-offcanvas")
    if (panel && panel.parentElement !== document.body) {
      document.body.appendChild(panel)
    }
  }

  openOffcanvas() {
    this.prepareOffcanvas()

    const panel = document.getElementById("notifications-offcanvas")
    if (!panel) return

    Offcanvas.getOrCreateInstance(panel).show()
  }
}
